import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = {
  id: "mydiv",
  class: "w-100 h-100"
}
const _hoisted_2 = { style: {"margin-left":"1%"} }
const _hoisted_3 = { style: {"position":"relative","display":"inline-table","align-items":"center","margin-top":"1%"} }
const _hoisted_4 = {
  id: "divByUserId",
  style: {"display":"inline-block","width":"500px","height":"190px","border":"none !important"}
}
const _hoisted_5 = {
  id: "tblByUserId",
  style: {"width":"500px","border":"none !important"}
}
const _hoisted_6 = { style: {"text-align":"left","width":"25px"} }
const _hoisted_7 = ["checked"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "2",
  style: {"text-align":"left"}
}, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "rdoByUserId",
    style: {"margin-left":"10px","display":"inline"}
  }, "By User ID")
], -1 /* HOISTED */)
const _hoisted_9 = { style: {"padding":"0"} }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("td", { style: {"width":"25px","display":"block"} }, null, -1 /* HOISTED */)
const _hoisted_11 = { style: {"border":"#ccc solid 0.5px","width":"400px"} }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("td", { style: {"text-align":"left","width":"170px","vertical-align":"top"} }, " User ID :", -1 /* HOISTED */)
const _hoisted_13 = { style: {"width":"230px","padding":"0.5% 6% 0.5% 0%","text-align":"left"} }
const _hoisted_14 = { style: {"color":"red","text-align":"left"} }
const _hoisted_15 = { style: {"width":"75px"} }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = {
  id: "divByMenu",
  style: {"display":"inline-block","width":"700px","height":"190px","margin-left":"15px","border":"none !important"}
}
const _hoisted_18 = {
  id: "tblByMenu",
  style: {"width":"700px","border":"none !important"}
}
const _hoisted_19 = { style: {"text-align":"left","width":"25px"} }
const _hoisted_20 = ["checked"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "2",
  style: {"text-align":"left"}
}, [
  /*#__PURE__*/_createElementVNode("label", {
    for: "rdoByMenu",
    style: {"margin-left":"10px","display":"inline"}
  }, "By Menu")
], -1 /* HOISTED */)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("td", { style: {"width":"25px","display":"block"} }, null, -1 /* HOISTED */)
const _hoisted_23 = { style: {"width":"600px"} }
const _hoisted_24 = { style: {"border":"#ccc solid 0.5px","width":"600px"} }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("td", { style: {"text-align":"left","width":"200px","padding-left":"6%"} }, " Area :", -1 /* HOISTED */)
const _hoisted_26 = { style: {"width":"400px","padding":"0.5% 6% 0% 0%","text-align":"left"} }
const _hoisted_27 = ["value"]
const _hoisted_28 = ["value"]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("td", { style: {"text-align":"left","padding-left":"6%"} }, "Station Code : ", -1 /* HOISTED */)
const _hoisted_30 = ["value"]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("td", { style: {"text-align":"left","padding-left":"6%"} }, "Main Title :", -1 /* HOISTED */)
const _hoisted_32 = ["value"]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("td", { style: {"text-align":"left","padding-left":"6%"} }, "Menu :", -1 /* HOISTED */)
const _hoisted_34 = ["value"]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("td", { style: {"text-align":"left","padding-left":"6%"} }, "Department : ", -1 /* HOISTED */)
const _hoisted_36 = { style: {"padding":"0% 6% 0.5% 0%"} }
const _hoisted_37 = ["value"]
const _hoisted_38 = { style: {"vertical-align":"top","width":"75px"} }
const _hoisted_39 = ["disabled"]
const _hoisted_40 = {
  id: "divNextPage",
  style: {"text-align":"right","margin-top":"2.5%"}
}
const _hoisted_41 = {
  key: 0,
  id: "divByUserResult",
  style: {"margin-top":"1%","border":"0.5px solid #ccc","height":"620px"}
}
const _hoisted_42 = {
  key: 0,
  id: "tblByUserIdResult",
  style: {"height":"50px","margin":"1% auto 1% auto","border":"none !important"}
}
const _hoisted_43 = /*#__PURE__*/_createElementVNode("td", { style: {"text-align":"left","width":"200px"} }, "User ID :", -1 /* HOISTED */)
const _hoisted_44 = { style: {"width":"200px"} }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("td", { style: {"text-align":"left","width":"200px","padding-left":"5%"} }, "User Name :", -1 /* HOISTED */)
const _hoisted_46 = { style: {"width":"200px"} }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("td", { style: {"text-align":"left"} }, "Company Name :", -1 /* HOISTED */)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("td", { style: {"text-align":"left","padding-left":"5%"} }, "Department :", -1 /* HOISTED */)
const _hoisted_49 = {
  key: 1,
  style: {"font-weight":"bold","border-bottom":"1px solid #00368f","width":"auto"}
}
const _hoisted_50 = {
  key: 2,
  style: {"height":"30px !important","width":"900px","display":"contents","overflow":"auto","margin-top":"0.75% auto auto 13%"}
}
const _hoisted_51 = /*#__PURE__*/_createElementVNode("table", {
  id: "tblByUserMenuResult",
  style: {"margin":"0% auto","height":"30px"}
}, [
  /*#__PURE__*/_createElementVNode("thead", null, [
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", { style: {"width":"10%"} }, "Menu Code"),
      /*#__PURE__*/_createElementVNode("th", { style: {"width":"30%"} }, "Main"),
      /*#__PURE__*/_createElementVNode("th", { style: {"width":"30%"} }, "Sub")
    ])
  ])
], -1 /* HOISTED */)
const _hoisted_52 = [
  _hoisted_51
]
const _hoisted_53 = {
  key: 3,
  id: "divByUserMenuResult",
  style: {"height":"450px","width":"900px","display":"flex","overflow":"auto","margin":"0% auto auto 13%"}
}
const _hoisted_54 = {
  id: "tblByUserMenuResult",
  style: {"margin":"0% 0% auto 0%"}
}
const _hoisted_55 = { id: "tbodyByUserMenuResult" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("td", { style: {"width":"10%"} }, null, -1 /* HOISTED */)
const _hoisted_57 = { style: {"width":"30%"} }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("td", { style: {"width":"30%"} }, null, -1 /* HOISTED */)
const _hoisted_59 = { style: {"text-align":"center","width":"10%"} }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("td", { style: {"width":"30%"} }, null, -1 /* HOISTED */)
const _hoisted_61 = { style: {"width":"30%"} }
const _hoisted_62 = {
  key: 1,
  id: "divPageNumber",
  style: {"text-align":"right","margin-top":"0.5%"}
}
const _hoisted_63 = {
  key: 2,
  id: "divByMenuResult",
  style: {"border":"0.5px solid #ccc","height":"370px"}
}
const _hoisted_64 = { id: "tblByMenuResult" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"15%","height":"37px"} }, "User ID"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"35%"} }, "User Name"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"20%"} }, "Station Code"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"20%"} }, "Department"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"10%"} })
  ])
], -1 /* HOISTED */)
const _hoisted_66 = { style: {"width":"15%","height":"auto"} }
const _hoisted_67 = { style: {"width":"35%"} }
const _hoisted_68 = { style: {"width":"20%"} }
const _hoisted_69 = { style: {"width":"20%"} }
const _hoisted_70 = { style: {"width":"10%"} }
const _hoisted_71 = ["onClick"]
const _hoisted_72 = { key: 0 }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "5",
  style: {"text-align":"center","border":"none"}
}, "No Data", -1 /* HOISTED */)
const _hoisted_74 = [
  _hoisted_73
]
const _hoisted_75 = {
  key: 3,
  id: "divPagination",
  class: "div-Pagination"
}
const _hoisted_76 = {
  key: 0,
  class: "column1"
}
const _hoisted_77 = /*#__PURE__*/_createElementVNode("label", null, "First Page", -1 /* HOISTED */)
const _hoisted_78 = [
  _hoisted_77
]
const _hoisted_79 = {
  key: 1,
  class: "column1"
}
const _hoisted_80 = {
  key: 2,
  class: "column2"
}
const _hoisted_81 = {
  key: 3,
  class: "column2"
}
const _hoisted_82 = /*#__PURE__*/_createElementVNode("label", null, "Last Page", -1 /* HOISTED */)
const _hoisted_83 = [
  _hoisted_82
]
const _hoisted_84 = {
  class: "modal fade",
  id: "detailUserPermissionModal",
  tabindex: "-1",
  "aria-labelledby": "showModalLabel",
  "aria-hidden": "true"
}
const _hoisted_85 = {
  class: "modal-dialog modal-dialog-scrollable modal-lg",
  style: {"height":"auto"}
}
const _hoisted_86 = {
  class: "modal-content",
  style: {"min-width":"1200px","margin-left":"10%","margin-right":"10%"}
}
const _hoisted_87 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title",
    id: "showModalLabel",
    style: {"text-align":"center","width":"1142px"}
  }, " Menu Permission List "),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1 /* HOISTED */)
const _hoisted_88 = {
  class: "modal-body",
  id: "modal-body",
  style: {"text-align":"left","height":"700px"}
}
const _hoisted_89 = {
  key: 0,
  id: "divDetailByUserResult",
  style: {"margin-top":"1.5%","border":"none","height":"650px"}
}
const _hoisted_90 = {
  key: 0,
  id: "tblDetailByUserIdResult",
  style: {"height":"50px","margin":"1% auto 1% auto"}
}
const _hoisted_91 = /*#__PURE__*/_createElementVNode("td", { style: {"text-align":"left","width":"200px"} }, "User ID :", -1 /* HOISTED */)
const _hoisted_92 = { style: {"width":"200px"} }
const _hoisted_93 = /*#__PURE__*/_createElementVNode("td", { style: {"text-align":"left","width":"200px","padding-left":"5%"} }, "User Name :", -1 /* HOISTED */)
const _hoisted_94 = { style: {"width":"200px"} }
const _hoisted_95 = /*#__PURE__*/_createElementVNode("td", { style: {"text-align":"left"} }, "Company Name :", -1 /* HOISTED */)
const _hoisted_96 = /*#__PURE__*/_createElementVNode("td", { style: {"text-align":"left","padding-left":"5%"} }, "Department :", -1 /* HOISTED */)
const _hoisted_97 = {
  key: 1,
  style: {"height":"30px","width":"900px","display":"flex","overflow":"hidden","margin":"0% auto auto 12%"}
}
const _hoisted_98 = /*#__PURE__*/_createElementVNode("table", {
  id: "tblDetailByUserMenuResult",
  style: {"margin":"0% auto","height":"30px"}
}, [
  /*#__PURE__*/_createElementVNode("thead", null, [
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("th", { style: {"width":"10%"} }, "Menu Code"),
      /*#__PURE__*/_createElementVNode("th", { style: {"width":"30%"} }, "Main"),
      /*#__PURE__*/_createElementVNode("th", { style: {"width":"30%"} }, "Sub")
    ])
  ])
], -1 /* HOISTED */)
const _hoisted_99 = [
  _hoisted_98
]
const _hoisted_100 = {
  key: 2,
  id: "tbodyDetailDiv",
  style: {"height":"550px","width":"900px","display":"flex","overflow-y":"auto","margin":"0% auto auto 12%"}
}
const _hoisted_101 = {
  id: "tblDetailByUserMenuResult",
  style: {"margin":"0% 0% auto 0%"}
}
const _hoisted_102 = { id: "tbodyDetailMenu" }
const _hoisted_103 = /*#__PURE__*/_createElementVNode("td", { style: {"width":"10%"} }, null, -1 /* HOISTED */)
const _hoisted_104 = { style: {"width":"30%"} }
const _hoisted_105 = /*#__PURE__*/_createElementVNode("td", { style: {"width":"30%"} }, null, -1 /* HOISTED */)
const _hoisted_106 = { style: {"text-align":"center","width":"10%"} }
const _hoisted_107 = /*#__PURE__*/_createElementVNode("td", { style: {"width":"30%"} }, null, -1 /* HOISTED */)
const _hoisted_108 = { style: {"width":"30%"} }
const _hoisted_109 = /*#__PURE__*/_createElementVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btnClose",
    "data-bs-dismiss": "modal"
  }, " Close ")
], -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      ($setup.isLoading)
        ? (_openBlock(), _createBlock($setup["Loading"], {
            key: 0,
            isLoading: $setup.isLoading
          }, null, 8 /* PROPS */, ["isLoading"]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_2, [
        _createVNode($setup["Alert"], {
          alertMessage: $setup.alertMessage,
          alertState: $setup.alertState
        }, null, 8 /* PROPS */, ["alertMessage", "alertState"])
      ]),
      _createVNode($setup["AdminNavigation"], { menuTile: $setup.title }, null, 8 /* PROPS */, ["menuTile"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_6, [
                  _createElementVNode("input", {
                    type: "radio",
                    id: "rdoByUserId",
                    style: {"display":"inline"},
                    name: "ByUserId",
                    value: "ByUserId",
                    onChange: _cache[0] || (_cache[0] = ($event: any) => ($setup.rdoCheckChange($event))),
                    checked: $setup.radioCheck == 'ByUserId'
                  }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_7)
                ]),
                _hoisted_8
              ]),
              _createElementVNode("tr", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("td", null, [
                  _createElementVNode("table", _hoisted_11, [
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _hoisted_12,
                        _createElementVNode("td", _hoisted_13, [
                          _withDirectives(_createElementVNode("input", {
                            class: "txt-form-control",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.inputUserId) = $event))
                          }, null, 512 /* NEED_PATCH */), [
                            [_vModelText, $setup.inputUserId]
                          ]),
                          _createElementVNode("span", _hoisted_14, _toDisplayString($setup.userIdError), 1 /* TEXT */)
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("td", _hoisted_15, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btnMenuSearch",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.goSearchByUser())),
                    disabled: $setup.radioCheck != 'ByUserId'
                  }, " Go ", 8 /* PROPS */, _hoisted_16)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("table", _hoisted_18, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_19, [
                  _createElementVNode("input", {
                    type: "radio",
                    id: "rdoByMenu",
                    style: {"display":"inline"},
                    name: "ByMenu",
                    value: "ByMenu",
                    onChange: _cache[3] || (_cache[3] = ($event: any) => ($setup.rdoCheckChange($event))),
                    checked: $setup.radioCheck == 'ByMenu'
                  }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_20)
                ]),
                _hoisted_21
              ]),
              _createElementVNode("tr", null, [
                _hoisted_22,
                _createElementVNode("td", _hoisted_23, [
                  _createElementVNode("table", _hoisted_24, [
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _hoisted_25,
                        _createElementVNode("td", _hoisted_26, [
                          _createElementVNode("select", {
                            class: "form-select search-form-select",
                            onChange: _cache[4] || (_cache[4] = ($event: any) => ($setup.areaChange($event))),
                            value: $setup.selectedArea
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.areaList[0], (area, index) => {
                              return (_openBlock(), _createElementBlock("option", {
                                class: "adjusting-option",
                                style: {},
                                key: index,
                                value: area.areaCode
                              }, _toDisplayString(area.area), 9 /* TEXT, PROPS */, _hoisted_28))
                            }), 128 /* KEYED_FRAGMENT */))
                          ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_27)
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _hoisted_29,
                        _createElementVNode("td", null, [
                          _withDirectives(_createElementVNode("select", {
                            class: "form-select search-form-select",
                            style: {},
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.selectedStation) = $event))
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.stationList, (station, index) => {
                              return (_openBlock(), _createElementBlock("option", {
                                class: "adjusting-option",
                                key: index,
                                value: station.stationCode
                              }, _toDisplayString(station.stationCode) + " : " + _toDisplayString(station.companyName), 9 /* TEXT, PROPS */, _hoisted_30))
                            }), 128 /* KEYED_FRAGMENT */))
                          ], 512 /* NEED_PATCH */), [
                            [_vModelSelect, $setup.selectedStation]
                          ])
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _hoisted_31,
                        _createElementVNode("td", null, [
                          _withDirectives(_createElementVNode("select", {
                            class: "form-select search-form-select",
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.selectedMainTitle) = $event)),
                            onChange: _cache[7] || (_cache[7] = ($event: any) => ($setup.getMenuyByTitle($event)))
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.mainTitleList[0], (tilteObj, index) => {
                              return (_openBlock(), _createElementBlock("option", {
                                class: "adjusting-option",
                                key: index,
                                value: tilteObj.mainTitleCode
                              }, _toDisplayString(tilteObj.mainTitleCode + ' : ' + tilteObj.mainTitleName), 9 /* TEXT, PROPS */, _hoisted_32))
                            }), 128 /* KEYED_FRAGMENT */))
                          ], 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                            [_vModelSelect, $setup.selectedMainTitle]
                          ])
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _hoisted_33,
                        _createElementVNode("td", null, [
                          _withDirectives(_createElementVNode("select", {
                            class: "form-select search-form-select",
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.selectedMenu) = $event))
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.menuList[0], (menuObj, index) => {
                              return (_openBlock(), _createElementBlock("option", {
                                class: "adjusting-option",
                                key: index,
                                value: menuObj.mainMenuCode
                              }, _toDisplayString(menuObj.mainMenuCode + ' : ' + menuObj.mainMenuName), 9 /* TEXT, PROPS */, _hoisted_34))
                            }), 128 /* KEYED_FRAGMENT */))
                          ], 512 /* NEED_PATCH */), [
                            [_vModelSelect, $setup.selectedMenu]
                          ])
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _hoisted_35,
                        _createElementVNode("td", _hoisted_36, [
                          _withDirectives(_createElementVNode("select", {
                            class: "form-select search-form-select",
                            style: {},
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.selectedDept) = $event))
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.departmentList, (department, index) => {
                              return (_openBlock(), _createElementBlock("option", {
                                class: "adjusting-option",
                                key: index,
                                value: department.group
                              }, _toDisplayString(department.group), 9 /* TEXT, PROPS */, _hoisted_37))
                            }), 128 /* KEYED_FRAGMENT */))
                          ], 512 /* NEED_PATCH */), [
                            [_vModelSelect, $setup.selectedDept]
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("td", _hoisted_38, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btnMenuSearch",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => ($setup.goSearchByMenu())),
                    disabled: $setup.radioCheck != 'ByMenu'
                  }, " Go ", 8 /* PROPS */, _hoisted_39)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("a", {
            style: {"color":"blue","cursor":"pointer","text-decoration":"underline"},
            onClick: _cache[11] || (_cache[11] = ($event: any) => ($setup.goToApprovalHistory()))
          }, "Approval History >>")
        ]),
        ($setup.radioCheck == 'ByUserId' && $setup.isSearch && $setup.userObj.length != 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
              ($setup.userObj.length != 0)
                ? (_openBlock(), _createElementBlock("table", _hoisted_42, [
                    _createElementVNode("tr", null, [
                      _hoisted_43,
                      _createElementVNode("td", _hoisted_44, [
                        _withDirectives(_createElementVNode("input", {
                          class: "txt-form-control",
                          style: {"width":"150px","background-color":"rgb(229 232 237)"},
                          disabled: "",
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.userObj[0].userId) = $event))
                        }, null, 512 /* NEED_PATCH */), [
                          [_vModelText, $setup.userObj[0].userId]
                        ])
                      ]),
                      _hoisted_45,
                      _createElementVNode("td", _hoisted_46, [
                        _withDirectives(_createElementVNode("input", {
                          class: "txt-form-control",
                          style: {"width":"250px","background-color":"rgb(229 232 237)"},
                          disabled: "",
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.userFullName) = $event))
                        }, null, 512 /* NEED_PATCH */), [
                          [_vModelText, $setup.userFullName]
                        ])
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_47,
                      _createElementVNode("td", null, [
                        _withDirectives(_createElementVNode("input", {
                          class: "txt-form-control",
                          style: {"background-color":"rgb(229 232 237)","width":"300px"},
                          disabled: "",
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (($setup.userObj[0].stationCode.companyName) = $event))
                        }, null, 512 /* NEED_PATCH */), [
                          [_vModelText, $setup.userObj[0].stationCode.companyName]
                        ])
                      ]),
                      _hoisted_48,
                      _createElementVNode("td", null, [
                        _withDirectives(_createElementVNode("input", {
                          class: "txt-form-control",
                          style: {"width":"250px","background-color":"rgb(229 232 237)"},
                          disabled: "",
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (($setup.userObj[0].department) = $event))
                        }, null, 512 /* NEED_PATCH */), [
                          [_vModelText, $setup.userObj[0].department]
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              ($setup.userObj.length != 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_49, "Menu Permission List"))
                : _createCommentVNode("v-if", true),
              ($setup.userObj.length != 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_50, _hoisted_52))
                : _createCommentVNode("v-if", true),
              ($setup.userObj.length != 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                    _createElementVNode("table", _hoisted_54, [
                      _createElementVNode("tbody", _hoisted_55, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.userMenuList[0], (main, index1) => {
                          return (_openBlock(), _createElementBlock(_Fragment, { key: index1 }, [
                            _createElementVNode("tr", null, [
                              _hoisted_56,
                              _createElementVNode("td", _hoisted_57, _toDisplayString(main.name), 1 /* TEXT */),
                              _hoisted_58
                            ]),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(main.data, (menu1, index2) => {
                              return (_openBlock(), _createElementBlock("tr", { key: index2 }, [
                                _createElementVNode("td", _hoisted_59, _toDisplayString(menu1.id), 1 /* TEXT */),
                                _hoisted_60,
                                _createElementVNode("td", _hoisted_61, _toDisplayString(menu1.name), 1 /* TEXT */)
                              ]))
                            }), 128 /* KEYED_FRAGMENT */))
                          ], 64 /* STABLE_FRAGMENT */))
                        }), 128 /* KEYED_FRAGMENT */))
                      ])
                    ])
                  ]))
                : _createCommentVNode("v-if", true)
            ]))
          : _createCommentVNode("v-if", true),
        ($setup.radioCheck == 'ByMenu' && $setup.isSearch)
          ? (_openBlock(), _createElementBlock("div", _hoisted_62, " Page " + _toDisplayString($setup.currentPageNo) + " / " + _toDisplayString($setup.pageCount), 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        ($setup.radioCheck == 'ByMenu' && $setup.isSearch)
          ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
              _createElementVNode("table", _hoisted_64, [
                _hoisted_65,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.userObjList, (user, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", _hoisted_66, _toDisplayString(user.userId), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_67, _toDisplayString(user.givenName + ' ' + user.familyName), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_68, _toDisplayString(user.stationcode), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_69, _toDisplayString(user.department), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_70, [
                        _createElementVNode("button", {
                          type: "button",
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#detailUserPermissionModal",
                          class: "btnDetailSearch",
                          onClick: ($event: any) => ($setup.goDetailSearchByUser(user))
                        }, " Detail ", 8 /* PROPS */, _hoisted_71)
                      ])
                    ]))
                  }), 128 /* KEYED_FRAGMENT */)),
                  ($setup.isNoData)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_72, _hoisted_74))
                    : _createCommentVNode("v-if", true)
                ])
              ])
            ]))
          : _createCommentVNode("v-if", true),
        ($setup.radioCheck == 'ByMenu' && $setup.isSearch)
          ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
              ($setup.currentPageNo == 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_76, _hoisted_78))
                : (_openBlock(), _createElementBlock("div", _hoisted_79, [
                    _createElementVNode("button", {
                      onClick: _cache[16] || (_cache[16] = ($event: any) => ($setup.changeUserPage('Back'))),
                      type: "button",
                      class: "btnDirection"
                    }, _toDisplayString($setup.userBackBtnText), 1 /* TEXT */)
                  ])),
              ($setup.pageCount > 1 && $setup.currentPageNo < $setup.pageCount)
                ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                    _createElementVNode("button", {
                      onClick: _cache[17] || (_cache[17] = ($event: any) => ($setup.changeUserPage('Next'))),
                      type: "button",
                      class: "btnDirection"
                    }, _toDisplayString($setup.userNextBtnText), 1 /* TEXT */)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_81, _hoisted_83))
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _createCommentVNode(" Modal "),
    _createElementVNode("div", _hoisted_84, [
      _createElementVNode("div", _hoisted_85, [
        _createElementVNode("div", _hoisted_86, [
          _hoisted_87,
          _createElementVNode("div", _hoisted_88, [
            ($setup.radioCheck == 'ByMenu')
              ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                  ($setup.userDetailObj.length != 0)
                    ? (_openBlock(), _createElementBlock("table", _hoisted_90, [
                        _createElementVNode("tr", null, [
                          _hoisted_91,
                          _createElementVNode("td", _hoisted_92, [
                            _withDirectives(_createElementVNode("input", {
                              class: "txt-form-control",
                              style: {"width":"150px","background-color":"rgb(237, 239, 242)"},
                              disabled: "",
                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (($setup.userDetailObj[0].userId) = $event))
                            }, null, 512 /* NEED_PATCH */), [
                              [_vModelText, $setup.userDetailObj[0].userId]
                            ])
                          ]),
                          _hoisted_93,
                          _createElementVNode("td", _hoisted_94, [
                            _withDirectives(_createElementVNode("input", {
                              class: "txt-form-control",
                              style: {"width":"250px","background-color":"rgb(229 232 237) !important"},
                              disabled: "",
                              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (($setup.userDetailFullName) = $event))
                            }, null, 512 /* NEED_PATCH */), [
                              [_vModelText, $setup.userDetailFullName]
                            ])
                          ])
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_95,
                          _createElementVNode("td", null, [
                            _withDirectives(_createElementVNode("input", {
                              class: "txt-form-control",
                              style: {"background-color":"rgb(229 232 237)","width":"300px"},
                              disabled: "",
                              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (($setup.userDetailObj[0].companyName) = $event))
                            }, null, 512 /* NEED_PATCH */), [
                              [_vModelText, $setup.userDetailObj[0].companyName]
                            ])
                          ]),
                          _hoisted_96,
                          _createElementVNode("td", null, [
                            _withDirectives(_createElementVNode("input", {
                              class: "txt-form-control",
                              style: {"width":"250px","background-color":"rgb(229 232 237)"},
                              disabled: "",
                              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (($setup.userDetailObj[0].department) = $event))
                            }, null, 512 /* NEED_PATCH */), [
                              [_vModelText, $setup.userDetailObj[0].department]
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("v-if", true),
                  ($setup.userDetailObj.length != 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_97, _hoisted_99))
                    : _createCommentVNode("v-if", true),
                  ($setup.userDetailObj.length != 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                        _createElementVNode("table", _hoisted_101, [
                          _createElementVNode("tbody", _hoisted_102, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.userDetailMenuList[0], (main, index1) => {
                              return (_openBlock(), _createElementBlock(_Fragment, { key: index1 }, [
                                _createElementVNode("tr", null, [
                                  _hoisted_103,
                                  _createElementVNode("td", _hoisted_104, _toDisplayString(main.name), 1 /* TEXT */),
                                  _hoisted_105
                                ]),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(main.data, (menu1, index2) => {
                                  return (_openBlock(), _createElementBlock("tr", { key: index2 }, [
                                    _createElementVNode("td", _hoisted_106, _toDisplayString(menu1.id), 1 /* TEXT */),
                                    _hoisted_107,
                                    _createElementVNode("td", _hoisted_108, _toDisplayString(menu1.name), 1 /* TEXT */)
                                  ]))
                                }), 128 /* KEYED_FRAGMENT */))
                              ], 64 /* STABLE_FRAGMENT */))
                            }), 128 /* KEYED_FRAGMENT */))
                          ])
                        ])
                      ]))
                    : _createCommentVNode("v-if", true)
                ]))
              : _createCommentVNode("v-if", true)
          ]),
          _hoisted_109
        ])
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}